import React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

// Top-level error boundary: without this, a single render exception blanks the whole app.
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Uncaught render error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ color: 'rgb(198, 198, 198)', textAlign: 'center', paddingTop: '20dvh', fontSize: '1.5dvw' }}>
                    <p>Something went wrong displaying the app.</p>
                    <button style={{ fontSize: '1.3dvw' }} onClick={() => window.location.reload()}>Reload Harmona</button>
                </div>
            );
        }
        return this.props.children;
    }
}
